<template>
  <v-tooltip right :color="col.color">
    <template v-slot:activator="{ on }">
      <div 
        v-on="on"
        @click="open_dialog()" 
        :class="{'pointer' : clickable}"
        @mouseover="calcEnh()"
      >
        <svg 
          style="margin-bottom: -5px; margin-top: 2px"
          :style="{'width' : bubble_size +2, 'height' : bubble_size+2}"
          :id="id_name"
          class="bubble"
        >
        </svg>
      </div>
    </template>
    <div class="text-center">
      <span class="title">
        {{format_perc(value)}}
      </span> de 5 <br>
      {{ies ? ies.siglas : axis && axis.nombre_corto || '?'}}
      <br>
      {{col.nombre_corto || col.nombre}}
      <span v-if="has_enhance">
        <br>
        <v-icon color="white">transit_enterexit</v-icon>
        *Registró avances en el año en curso
      </span>
    </div>
  </v-tooltip>
</template>

<script>

import * as d3 from 'd3';
import * as d3Array from 'd3-array';

export default {
  name: 'BubbleChart',
  components: {

  },
  props:{
    col:{
      type: Object,
      required: true,
    },
    ies:{
      type: Object,
      required: false,
    },
    axis:{
      type: Object,
      required: false,
    },
    period:{
      type: Object,
      required: false,
    },
    indicador:{
      type: Object,
      required: false,
    },
    resize:{
      type: Boolean,
      required: false,
      default: false,
    },
    value:{
      type: Number,
      required: false,
      default: 0,
    },
    mean:{
      type: String,
      required: false,
      default: '',
    },
    clickable:{
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data(){
    return {
      //bubble_size: this.$vuetify.breakpoint.xsOnly ? 30 : 58,
      has_enhance: false,
    }
  },
  computed:{
    bubble_size(){
      return this.resize && this.$vuetify.breakpoint.xsOnly ? 30 : 58
    },
    id_name(){
      return `ies${
        this.ies && this.ies.id || '0'}-eje${
        this.axis && this.axis.id || '0'}-ind${
        this.indicador && this.indicador.id || '0'}-year${
        this.period && this.period.year || '0'}${
        this.mean}`
    },
  },
  created(){
    this.$nextTick( () =>{
      this.drawBolitas()
    })
  },  
  watch: {
    value(after, before){
      if (this.axis){
        this.$nextTick( () =>{
          this.updateBolitas()
        })
      }
    },
    id_name(after, before){
      this.$nextTick( () =>{
        this.updateBolitas()
      })
    },
  },
  methods: {
    format_perc(v){
      return d3.format('.1f')(v)
    },
    calcEnh(){
      if (this.col.id == 'index' && !this.ies && !this.ies.id)
        return
      this.has_enhance = this.hasEnhace()
    },
    hasEnhace(){
      try{
        return d3.select(`svg${this.id_name}`).classed("has_enhace")
      }
      catch(err){
        return false
      }
    },
    updateBolitas(){
      this.drawBolitas()
    },
    open_dialog(){
      if (!this.clickable) return
      if (this.col.id == 'index' && !this.ies && !this.ies.id)
        return
      this.$emit('open_intercard', [
        this.col.id, this.ies.id, this.value, this.hasEnhace()])
    },
    drawBolitas(){
      var id_name = this.id_name//`#ies${this.ies.id}-eje${this.col.id}${this.mean}`
      const rect = d3.select(`svg#${id_name}`)

      const t = rect.transition()
          .duration(1500);

      var vm = this

      var size = vm.bubble_size / 2
      var size2 = vm.bubble_size / 2 + 1

        var out_circle = rect
          .selectAll('.out_circle')
            .data([1])
            .enter().append("circle")
            .classed("out_circle", true)
            .attr('cy', size2)
            .attr('cx', size2)
            .attr('r', size)
            .attr('fill', "transparent")
            .attr('stroke', '#e2e2e2')
          /*.join("circle")
          .classed("bolita", true)
          .attr('cy', this.bubble_size/2)
          .attr('cx', this.bubble_size/2)
          .attr('r', (d) => d * (this.bubble_size/ 10))*/



      if (vm.ies && vm.ies.id == 9999){
        console.log(size2)
      }
      var circle = rect
        .selectAll('.bolita')
        .data([vm.value], d=>d)
          //.enter()
          //.join("circle")
          .join(
            enter => enter.append('circle')
                .classed("bolita", true)
                .attr("r", 0)
                .attr('cy', size2)
                .attr('cx', size2)
              .call(enter => enter.transition(t)
                .attr('r', (d) => {
                  if (vm.ies && vm.ies.id == 9999){
                    console.log(d)
                    console.log(vm.bubble_size)
                    console.log(d * (vm.bubble_size/ 10))
                    console.log("---------------")
                  }
                  return (d * (vm.bubble_size/ 10))
                })),
          )
            .attr('fill', vm.col.color)

          

    },
  },
}
</script>

<style lang="scss" scoped>
  .experiment{
    color:blue;
  }
  .special-table th{
    height: 80px !important;
  }
  .width120{
    max-width: 120px;    
  }
  .width80{
    max-width: 82px;    
  }
  .width60{
    max-width: 60px;    
  }
  .width30{
    max-width: 30px;
  }
  .all_bg{
    background-color: #f1f1f1;
  }
</style>